import { BrowserModule } from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { UiModule } from './ui/ui.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { LoginComponent } from './auth/login/login.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { RecoverPasswordComponent } from './auth/recover-password/recover-password.component';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxPaginationModule } from 'ngx-pagination';
import { ActivateAccountComponent } from './auth/activate-account/activate-account.component';
import {RemoveAccountComponent} from "./auth/remove-account/remove-account.component";
import {GlobalErrorHandler} from "./core/error-handler/global-error-handler.service";
@NgModule({ declarations: [
        AppComponent,
        LoginComponent,
        ForgotPasswordComponent,
        RecoverPasswordComponent,
        ActivateAccountComponent,
        RemoveAccountComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule, // required animations module
        ToastrModule.forRoot(),
        NgxPaginationModule,
        AppRoutingModule,
        CoreModule,
        ReactiveFormsModule,
        FormsModule,
        UiModule,
      ],
      providers: [
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
